/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  FormHelperText
} from '@material-ui/core';
import DuplicateIcon from '../icons/Duplicate';
import XIcon from '../icons/X';
import bytesToSize from '../utils/bytesToSize';
import { AttachFile } from '@material-ui/icons';

const FileDropzoneButton = (props) => {
  const {
    accept,
    disabled,
    files,
    getFilesFromEvent,
    maxFiles,
    maxSize,
    minSize,
    noClick,
    noDrag,
    noDragEventsBubbling,
    noKeyboard,
    onDrop,
    onDropAccepted,
    onDropRejected,
    onFileDialogCancel,
    onRemove,
    onRemoveAll,
    onUpload,
    preventDropOnDocument,
    uploadShow,
    uploadInputShow,
    title,
    subTitle,
    id,
    removeButtonShow,
    showHelperText,
    ...other
  } = props;

  // We did not add the remaining props to avoid component complexity
  // but you can simply add it if you need to.
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    maxFiles,
    maxSize,
    minSize,
    onDrop
  });
  return (
    <div {...other}>
      {
        uploadInputShow && (
          <Box
            {...getRootProps()}
            onClick={() => { }}
            style={{ height: 'unset' }}
          >
            <input
              {...getInputProps()}
              id={id}
            />
            <label htmlFor={id}>
              <Button
                startIcon={<AttachFile />}
                variant="contained"
                color="primary"
                component="span"
                size="small"
              >
                Dosya Yükle
              </Button>
              {
                showHelperText && (
                  <FormHelperText>(Resim, Teknik Şartname vb. Belge ekle)</FormHelperText>
                )
              }
            </label>
            {files.length > 0 && (
              <Box
                sx={{
                  mt: 2,
                }}
              >
                <List>
                  {removeButtonShow ? files.map((file) => (
                    <ListItem
                      key={file.path}
                      sx={{
                        border: 1,
                        borderColor: 'divider',
                        borderRadius: 1,
                        '& + &': {
                          mt: 1
                        }
                      }}
                    >
                      <ListItemIcon>
                        <DuplicateIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={file.name}
                        primaryTypographyProps={{
                          color: 'textPrimary',
                          variant: 'subtitle2'
                        }}
                        secondary={file.size ? bytesToSize(file.size) : ''}
                      />
                      <Tooltip title="Sil">
                        <IconButton
                          edge="end"
                          onClick={() => onRemove && onRemove(file)}
                        >
                          <XIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </ListItem>
                  ))
                    : (<></>)}
                </List>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: 'unset'
                  }}
                >
                  {
                    ((maxFiles && maxFiles > 1) || !maxFiles) && (
                      <Button
                        color="primary"
                        onClick={onRemoveAll}
                        size="small"
                        type="button"
                        variant="text"
                      >
                        Hepsini Kaldır
                      </Button>
                    )
                  }

                  {uploadShow && (
                    <Button
                      color="primary"
                      onClick={onUpload}
                      size="small"
                      sx={{ ml: 2 }}
                      type="button"
                      variant="contained"
                    >
                      Güncelle
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        )
      }
    </div>
  );
};

FileDropzoneButton.propTypes = {
  accept: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  disabled: PropTypes.bool,
  files: PropTypes.array,
  getFilesFromEvent: PropTypes.func,
  maxFiles: PropTypes.number,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  noClick: PropTypes.bool,
  noDrag: PropTypes.bool,
  noDragEventsBubbling: PropTypes.bool,
  noKeyboard: PropTypes.bool,
  onDrop: PropTypes.func,
  onDropAccepted: PropTypes.func,
  onDropRejected: PropTypes.func,
  onFileDialogCancel: PropTypes.func,
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
  onUpload: PropTypes.func,
  preventDropOnDocument: PropTypes.bool,
  uploadShow: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  uploadInputShow: PropTypes.bool,
  removeButtonShow: PropTypes.bool,
  id: PropTypes.string,
  showHelperText: PropTypes.bool,
};

FileDropzoneButton.defaultProps = {
  files: [],
  title: 'Dosya seç',
  subTitle: 'Dosyayı buraya sürükleyerek de seçmiş olursunuz',
  uploadInputShow: true,
  removeButtonShow: true,
  id: 'contained-button-file',
  showHelperText: true,
};

export default FileDropzoneButton;
